// src/pages/Forbidden.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function Forbidden() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-base-200">
      <h1 className="text-4xl font-bold text-red-500 mb-4">403 — Доступ запрещён</h1>
      <p className="mb-6">У вас нет прав для просмотра этой страницы.</p>
      <Link to="/" className="btn btn-primary">
        На главную
      </Link>
    </div>
  );
}
